import React from "react";
import "../influencer/css/influencer.css";
import Select from "react-select/creatable";
import { useEffect } from "react";
import { useState } from "react";
import makeAnimated from "react-select/animated";

const makeAnimatedComp = makeAnimated();

const VendorCategory = ({
  customStyle,
  customStyles,
  userData,
  category,
  handleChange,
  isMulti = true,
  handleNewCategoryChange,
}) => {
  const [options, setOptions] = useState([{ value: "", label: "" }]);

  const handleInputChange = (inputValue, actionMeta) => {
    handleNewCategoryChange(inputValue);

    if (actionMeta.action === "menu-close") {
    }
  };

  useEffect(() => {
    let opt = [];
    category.map((c) => {
      opt.push({ value: c._id, label: c.name });
    });
    setOptions(opt);
  }, [category]);

  return (
    <div className="col" style={customStyle}>
      <Select
        styles={customStyles}
        className="scroll mb-2"
        components={makeAnimatedComp}
        placeholder="Vendor Category"
        isMulti={isMulti}
        onChange={handleChange}
        options={options}
        isClearable={true}
        isSearchable={true}
      // value={userData.category}
      // onInputChange={handleInputChange}
      // isLoading={loading}
      // defaultInputValue={["name", "name2"]}
      // defaultMenuIsOpen={["Art"]}
      // defaultValue={"Art"}
      // closeMenuOnSelect={false}
      />
    </div>
  );
};

export default VendorCategory;
